var base = require('settings/teams/send-invitation');

Vue.component('spark-send-invitation', {
    mixins: [base],
    
    data() {
        return {
            locations: [],
            locations_selected: null,
            form: new SparkForm({
                name: '',
                email: '',
                location_ids: [],
                role: this.defaultRole
            })
        };
    },

    created() {
        this.getLocations();
    },

    watch: {
        locations_selected() {
            this.form.location_ids = this.locations_selected.map(l => l.id);
        },

        'form.email'() {
            this.form.email = this.form.email.toLowerCase();
        }
    },

    methods: {
        getLocations() {
            return this.$http.get(this.$laroute.route('api.users.accessible-locations', { user: this.user.id }))
                .then(({ data }) => this.locations = data.data);
        },


        send() {
            Spark.post(this.$laroute.route('api.settings.send-user-invitations', {team: this.team.id}), this.form)
                .then(() => {
                    this.form.name  = '';
                    this.form.email = '';
                    this.form.role  = this.defaultRole;

                    this.$parent.$emit('updateInvitations');
                });
        },
    }
});
